import api from '../../plugins/api';

// GET /crm/cars/getDcRequisites?dcId= â Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ðµ Ð¸ ÑÑÐ¸Ð´Ð¸ÑÐµÑÐºÐ¸Ðµ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ
// Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°. ÐÐ¼Ð¸ Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÑÑÑ Ð±Ð»Ð¾Ðº Â«Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑÂ» Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ.
// ÐÑÐ²ÐµÑ: { name, bin, iban, bankName, bic, kbe, address, directorName, directorBasis }
const getDcRequisites = (dcId) => {
  return api.get('/api/crm/cars/getDcRequisites', { dcId });
};

export default getDcRequisites;
